import { Container, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";
import Post from "../components/Post";
import { db } from "../firebase";
import Footer from "./Footer";
import Loading from "./Loading";

function FoodLists({ filters }) {
  const email = useAuth().currentUser.email;
  const { searchValue } = filters;
  const [foods, setFoods] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [cart, setCart] = useState({});
  const [loading, setLoading] = useState(true);

  async function populateData() {
    let foodData = [];
    await db
      .collection("restaurants")
      .get()
      .then(async (e) => {
        for (const restaurant of e.docs) {
          for (const category of restaurant.data().categories) {
            await db
              .collection("restaurants")
              .doc(restaurant.id)
              .collection(category)
              .get()
              .then(async (item) => {
                for (const post of item.docs) {
                  foodData.push({
                    ...post.data(),
                    displayName: restaurant.data().displayName,
                  });
                }
              });
          }
        }
      });
    setFoods(foodData);
  }

  async function populateFavsAndCart() {
    const mCart = {};
    await db
      .collection("userData")
      .doc(email)
      .get()
      .then(function (e) {
        console.log("GET FAVS");
        const fav = e.data().favorites;
        setFavorites(fav);
        const car = e.data().cart;
        for (const order of car) {
          mCart[order.ref] = order.quantity;
        }
      });
    setCart(mCart);
    setLoading(false);
  }

  useEffect(() => {
    populateData();
    populateFavsAndCart();
  }, []);

  if (loading) return <Loading />;

  return (
    <>
      <Container>
        <Grid
          container
          spacing={4}
          justify="space-between"
          alignItems="stretch"
        >
          {foods.map((post) => {
            if (searchValue !== "") {
              if (
                post.title.toLowerCase().includes(searchValue.toLowerCase()) ||
                post.displayName
                  .toLowerCase()
                  .includes(searchValue.toLowerCase()) ||
                post.category.toLowerCase().includes(searchValue.toLowerCase())
              ) {
                return (
                  <Grid item xs={12} sm={6} md={4}>
                    <Post
                      props={post}
                      isfav={favorites.includes(post.ref)}
                      cart={cart}
                    />
                  </Grid>
                );
              }
            } else {
              return (
                <Grid item xs={12} sm={6} md={4}>
                  <Post
                    props={post}
                    isfav={favorites.includes(post.ref)}
                    cart={cart}
                  />
                </Grid>
              );
            }
          })}
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

export default FoodLists;
